import { cn } from '@/lib/utils'
import { SYMBOL_LEFT, SYMBOL_RIGHT } from '@/components/encuentro/page/encuadre-motif'

/**
 * Encuadre at cover scale, for the public site (brand manual Encuentro 1.1,
 * "Encuadre, Ventana y Trama"): the two pieces of the symbol, enlarged and
 * pulled apart so they open a space for content. On white the left piece is
 * `brand` blue and the right one `spark`; on a blue band (`tone="onBrand"`)
 * the left one turns white. One colour per piece, never the logo's colours
 * swapped, scaled proportionally (the viewBox keeps its ratio).
 *
 * `EncuadreMotif` (components/encuentro/page) is the product's version, only
 * for empty states and in `highlight`; this one is the brand's cover motif and
 * only lives in components/encuentro/marketing.
 *
 * Decorative: `aria-hidden`, never a heading, never behind body text.
 */
export function EncuadreFrame({
  tone = 'onWhite',
  className,
}: {
  tone?: 'onWhite' | 'onBrand'
  className?: string
}) {
  return (
    <svg
      data-slot="encuadre-frame"
      viewBox="0 0 176 128"
      aria-hidden="true"
      focusable="false"
      className={cn('pointer-events-none select-none', className)}
    >
      <path d={SYMBOL_LEFT} className={tone === 'onBrand' ? 'fill-en-bg' : 'fill-en-brand'} />
      <path d={SYMBOL_RIGHT} transform="translate(24 0)" className="fill-en-spark" />
    </svg>
  )
}

/**
 * One piece of the Encuadre on its own, cropped to its bounds (left piece
 * 56 × 104 units, right piece 56 × 88), so a layout can place each one
 * against an edge the way the manual's Encuadre sheet does: the blue piece
 * cut by the top left, the spark piece by the bottom right, and the content
 * in the space they open.
 */
export function EncuadrePiece({
  piece,
  tone = 'onWhite',
  className,
}: {
  piece: 'left' | 'right'
  tone?: 'onWhite' | 'onBrand'
  className?: string
}) {
  const left = piece === 'left'
  return (
    <svg
      data-slot="encuadre-piece"
      viewBox={left ? '16 8 56 104' : '80 32 56 88'}
      aria-hidden="true"
      focusable="false"
      className={cn('pointer-events-none select-none', className)}
    >
      <path
        d={left ? SYMBOL_LEFT : SYMBOL_RIGHT}
        className={left ? (tone === 'onBrand' ? 'fill-en-bg' : 'fill-en-brand') : 'fill-en-spark'}
      />
    </svg>
  )
}
